// extracted by mini-css-extract-plugin
export default {"cls1":"Comment-cls1_IHZ","cls2":"Comment-cls2__v9 Comment-cls1_IHZ"};